import React from "react";
import styled from "styled-components";
import { Button, Grid } from "@material-ui/core";
import { Done, Clear } from "@material-ui/icons";

const NewButton = styled(Button)`
  && {
    margin-left: 8px;
    padding: 8px 8px 8px 2px;
    border-radius: 0;
    color: #2196f3;
    background: none;
  }
  &&:hover {
    background: none;
  }
`;

const StyledSaveButton = styled(Button)`
  && {
    margin-left: 4px;
    padding: 7px 16px 7px 8px;
    border-radius: 0;
    color: rgb(255, 255, 255);
    background-color: rgba(0, 157, 223, 1);
  }
  &&:hover {
    background: rgba(0, 157, 223, 1);
  }
`;

const Container = styled.div`
  border-width: 0px;
  height: 76px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
`;

const SaveButton = props => (
  <StyledSaveButton variant="contained" onClick={props.onClick}>
    <Done />
    SAVE
  </StyledSaveButton>
);

const CancelButton = props => (
  <NewButton variant="contained" onClick={props.onClick}>
    <Clear />
    CANCEL
  </NewButton>
);

const NewDealHeader = props => (
  <Container>
    <Grid
      container
      direction="row"
      justify="flex-start"
      alignItems="center"
      spacing={8}
    >
      <Grid item>
        <div className="title-component">Deal Details</div>
      </Grid>
      <Grid item>
        <CancelButton onClick={props.cancel} />
      </Grid>

      <Grid item>
        <SaveButton onClick={props.saveDeal} />
      </Grid>
    </Grid>
  </Container>
);

export default NewDealHeader;
